import styled from 'styled-components';
import { BandsList } from '@widgets/GenericBookings/components/AttendeesSelector/components/Band/styles';
import { DummyLink } from '@genericBookings/components/SelectedOption/styles';
export const Close = styled.button `
  appearance: none;
  -webkit-appearance: none;
  cursor: pointer;
  display: flex;
  background-color: transparent;
  border: none;
  padding: 0;
  position: absolute;
  top: var(--modal-close-position-y);
  right: var(--modal-close-position-x);

  svg {
    pointer-events: none;
    fill: var(--modal-close-fill);
  }
`;
export const Inner = styled.div `
  padding: 2rem;
  width: calc(100% - 4rem);
  position: relative;
  max-width: 42rem;
  background-color: white;
  border-radius: var(--border-radius-sm);
  display: flex;
  flex-direction: column;

  #fitness-page & {
    &, p, h1, h2, h3, h4, h5, h6, .h1, .h2, .h3, .h4, .h5, .h6 {
      color: var(--navy-darker);
    }
  }

  h1,h2,h3,h4,h5,h6 {
    color: inherit;
    font-family: var(--heading-font);
  }

  & > svg {
    fill: var(--primary-darker);
  }

  p{
    color: inherit;
    font-family: var(--body-font);
  }
  
  ${BandsList} + button.btn.btn--primary {
    margin-top: 2rem;
  }
`;
export const Backdrop = styled.div `
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: var(--modal-background-gradient);
  background-color: var(--modal-background-color);
  backdrop-filter: var(--modal-background-blur);
  z-index: 100;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  overflow-y: scroll;
  padding: 5rem 0;
  ${({ theme: { noticeBackdrop } }) => noticeBackdrop}
`;
export const Header = styled.div `
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 1rem;
`;
export const Heading = styled.span `
  font: var(--heading-three-font);
  color: var(--primary-darker);
`;
export const SubHeading = styled.span `
  font: var(--paragraph-font);
  color: var(--primary-darker);
`;
export const Content = styled.div `
  padding-right: 1.6rem;
  //max-height: 32rem;
  margin-top: 0.6rem;
  //overflow-y: scroll;
  
  &.terms {
    text-align: left;
  }
`;
export const Controls = styled.div `
  margin-top: 1.5rem;
  .form__label {
    font: var(--paragraph-medium-font);
    font-weight: 600;
    &::before {
      margin-right: 0.5rem;
      position: relative;
      top: -0.1rem;
    }
  }

  .form__actions {
    margin-top: 1.5rem;
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    align-items: center;
    .btn {
      width: 100%;
    }
    
    ${DummyLink} {
      flex: initial;
    }
  }
`;
export default {
    Backdrop,
    Close,
    Inner,
    Header,
    Content,
    Heading,
    SubHeading,
    Controls,
};
